import React, { FC, memo } from "react";
import moment from "moment/moment";
import { useTranslation } from "react-i18next";
import { ContainerFilledCircle, FilledCircle } from "./styled";
import ActivityStatusDate from "../../../enums/ActivityStatusDate";
import { IDetailedProject } from "../../Project";

interface IStatusDateProps {
  beginDate: string;
  endDate: string;
  date_begin_activity: string;
  status: string;
}

const StatusDateExpected: FC<IStatusDateProps> = memo(
  ({ endDate, beginDate, date_begin_activity, status }): JSX.Element => {
    const { t } = useTranslation(["activities"]);

    const currentDateFormat = moment(moment().utc())
      .subtract(3, "hours")
      .format("YYYY-MM-DD");
    const beginDateFormat = moment(beginDate).format("YYYY-MM-DD");
    const endDateFormat = moment(endDate).format("YYYY-MM-DD");

    if (status === "CANCELED") {
      return (
        <ContainerFilledCircle>
          <FilledCircle color="red" />
          {t(`status_date.${ActivityStatusDate.Cancelled}`)}
        </ContainerFilledCircle>
      );
    }

    if (status === "EXECUTED") {
      return (
        <ContainerFilledCircle>
          <FilledCircle color="lightblue" />
          {t(`status_date.${ActivityStatusDate.Executed}`)}
        </ContainerFilledCircle>
      );
    }
    /*
    const projectType = project?.; */

    if (
      (!moment(beginDateFormat).isValid() ||
        !moment(endDateFormat).isValid()) &&
      !!date_begin_activity
    ) {
      return (
        <ContainerFilledCircle>
          <FilledCircle color="lightgreen" />
          {t(`status_date.${ActivityStatusDate.Start}`)}
        </ContainerFilledCircle>
      );
    }

    const isBeforeCurrentDate = moment(currentDateFormat).isSameOrBefore(
      endDateFormat,
    );

    const isAfterCurrentDate = moment(currentDateFormat).isSameOrAfter(
      beginDateFormat,
    );

    if (isBeforeCurrentDate && isAfterCurrentDate && !!date_begin_activity) {
      return (
        <ContainerFilledCircle>
          <FilledCircle color="green" />
          {t(`status_date.${ActivityStatusDate.StartOnTime}`)}
        </ContainerFilledCircle>
      );
    }

    /* if (isBeforeCurrentDate && isAfterCurrentDate && !date_begin_activity) {
      return (
        <ContainerFilledCircle>
          <FilledCircle color="gray" />
          {t(`status_date.${ActivityStatusDate.NoStart}`)}
        </ContainerFilledCircle>
      );
    } */

    if (!isBeforeCurrentDate && isAfterCurrentDate && !!date_begin_activity) {
      return (
        <ContainerFilledCircle>
          <FilledCircle color="orange" />
          {t(`status_date.${ActivityStatusDate.StartAndDelayed}`)}
        </ContainerFilledCircle>
      );
    }

    if (!isBeforeCurrentDate && isAfterCurrentDate && !date_begin_activity) {
      return (
        <ContainerFilledCircle>
          <FilledCircle color="red" />
          {t(`status_date.${ActivityStatusDate.NoStartAndDelayed}`)}
        </ContainerFilledCircle>
      );
    }

    return (
      <ContainerFilledCircle>
        <FilledCircle color="gray" />
        {t(`status_date.${ActivityStatusDate.NoStart}`)}
      </ContainerFilledCircle>
    );
  },
);

export default StatusDateExpected;
